export const breakpoints = {
  small: "768px",
  medium: "992px",
};
